module.exports = __webpack_public_path__ + "img/class_schedule.18b6f0db.png";